import React from 'react';
import { Product } from 'bootstrap/data/product/Product';
import { useSingleProductLogic } from 'subscription/singleproduct/SingleProductPayment.hook';
import { TenMinuteTimer } from 'livensubscription/components/timer/Timer';

import styles from './styles.module.scss';

type Props = {
  defaultProduct: Product;
  products: Map<string, Product>;
  paymentFormRef?: React.RefObject<HTMLDivElement>;
};

export const Header = ({ defaultProduct, products, paymentFormRef }: Props) => {
  const { handleGetPlanClick } = useSingleProductLogic({
    defaultProduct,
    products,
    paymentFormRef,
  });

  return (
    <header className={styles.appHeader}>
      <div className={styles.timer}>
        <TenMinuteTimer />
      </div>

      <button className={styles.submit} onClick={handleGetPlanClick}>
        GET MY PLAN
      </button>
    </header>
  );
};
